import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from 'ionic-angular';
import { ControlMessageModule } from '../../../modules-other/control-message/control-messages.module';
import { SelectControlConfigComponent } from './select-control-config.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        ControlMessageModule
    ],
    declarations: [
        SelectControlConfigComponent
    ],
    exports: [
        SelectControlConfigComponent
    ],
    entryComponents: [
        SelectControlConfigComponent
    ]
})
export class SelectControlConfigModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/select/config/select-control-config.module.ts